var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isComponentDefined == false)?_c('div',[_c('dashboard-empty')],1):_c(_vm.nameOfComponent,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }